import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'

interface Props {
  testcaseId: string
  modelId: string
  onSuccess: () => void
  children?: () => void
}

const DeleteModelerModelTestCaseRequest = ({
  testcaseId,
  modelId,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/models/${modelId}/test_cases/${testcaseId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteModelerModelTestCaseRequest
